import axios from "axios";

// Common Interceptor Logic
const setupInterceptors = (instance) => {
  // Request Interceptor
  instance.interceptors.request.use(
    async (config) => {
      const accessToken = localStorage.getItem("clientToken");
      if (accessToken) {
        config.headers["X-Token"] = accessToken;
      }
      return config;
    },
    (error) => {
      return Promise.reject(error);
    }
  );

  // Response Interceptor
  instance.interceptors.response.use(
    (response) => response,
    async (error) => {
      const originalRequest = error.config;

      if (error?.response?.status === 500) {
        return Promise.reject({
          isError: true,
          errorCode: 500,
          errorMsg: error.response.data.message,
        });
      }

      if (error?.response?.status === 403) {
        return Promise.reject({
          clientToken: null,
          errorCode: 403,
          errorMsg: error.response.data.message,
        });
      }

      if (error?.response?.status === 404) {
        return Promise.reject({
          isError: true,
          errorCode: 404,
          errorMsg: error.response.data.message,
        });
      }

      if (error?.response?.status === 401 && !originalRequest._retry) {
        console.log("originalRequest", originalRequest);
        originalRequest._retry = true;
        try {
          const response = await axios.post(
            `${process.env.REACT_APP_ADMIN_API_URL}/auth/refresh-token`,
            {
              withCredentials: true,
            }
          );

          console.log("response", response);
          const newAccessToken = response.data.accessToken;
          localStorage.setItem("clientToken", newAccessToken);
          originalRequest.headers["X-Token"] = newAccessToken;
          return instance(originalRequest);
        } catch (refreshError) {
          console.error("Token refresh failed, logging out...", refreshError);
          localStorage.removeItem("clientToken");
          return Promise.reject(refreshError);
        }
      }

      if (error?.code === "ERR_NETWORK") {
        return Promise.reject({
          isError: true,
          errorCode: "ERR_NETWORK",
          errorMsg: "Network Error: Unable to connect to the server",
        });
      }

      return Promise.reject({
        isError: true,
        errorCode: "*",
        errorMsg: error.response?.data?.message || "Unable to perform request",
      });
    }
  );
};

// Axios Instance for Web Backend
export const webAPI = axios.create({
  baseURL: process.env.REACT_APP_WEB_API_URL,
  headers: { 'Content-Type': 'application/json' },
  withCredentials: true,
});

// Axios Instance for Admin Backend
export const adminAPI = axios.create({
  baseURL: process.env.REACT_APP_ADMIN_API_URL,
  headers: { 'Content-Type': 'application/json' },
  withCredentials: true,
});

// Apply interceptors to both instances
setupInterceptors(webAPI);
setupInterceptors(adminAPI);
